import {
  Button as HUIButton,
  ButtonProps as HUIButtonProps,
} from '@headlessui/react';
import { ElementType, forwardRef } from 'react';
import { cx } from '@/utils/cx';
import { ButtonVariant } from './types/button-variant';

import './button.css';

export type ButtonProps<TTag extends ElementType = 'button'> =
  HUIButtonProps<TTag> & {
    className?: string;
    variant?: ButtonVariant;
  };

export const Button = <TTag extends ElementType = 'button'>({
  children,
  variant = 'primary',
  ...props
}: ButtonProps<TTag>): JSX.Element => (
  <HUIButton
    {...props}
    className={cx(
      'focusable',
      variant !== 'unstyled' && `button button-${variant}`,
      props.className,
    )}
  >
    {children}
  </HUIButton>
);

// TODO: remove duplication
export const ButtonWithForwardRef = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ children, variant = 'primary', ...props }, ref) => (
    <HUIButton
      {...props}
      className={cx(
        'focusable',
        variant !== 'unstyled' && `button button-${variant}`,
        props.className,
      )}
      ref={ref}
    >
      {children}
    </HUIButton>
  ),
);
